import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  Input,
  Label,
  Row,
  FormFeedback,
  Badge
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// API YAPILANDIRMASI
const API_BASE_URL = "https://tazelyapi.stechomeyazilim.info";
const USERS_ENDPOINT = `${API_BASE_URL}/Users`;
const NOTIFICATION_POST_URL = "https://tazelyadmin.stechomeyazilim.info:5556/addPushGitti/send";

const EcommerceAddProduct = () => {
  document.title = "Bildirim Yönetimi | Tazelya Admin Paneli";

  // State Yönetimi
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  // --- VERİ ÇEKME (FETCH) ---
  const fetchUsers = async () => {
    try {
      setIsLoading(true);
      // Sadece ID ve İsim alanlarını çekiyoruz (Performans için)
      const response = await axios.get(`${USERS_ENDPOINT}?$select=ID,Users_Name`);
      setUsers(response.data.value || []);
      setIsLoading(false);
    } catch (error) {
      console.error("Kullanıcılar çekilemedi:", error);
      showToast(false, "Kullanıcı listesi yüklenemedi.");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  // --- FORM YÖNETİMİ ---
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: '',
      desc: '',
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Bildirim başlığı zorunludur"),
      desc: Yup.string().required("Bildirim içeriği zorunludur"),
    }),
    onSubmit: async (values) => {
      if (selectedUsers.length === 0) {
        showToast(false, "Lütfen en az bir kullanıcı seçiniz.");
        return;
      }

      try {
        // Seçilen her bir kullanıcı ID'si için paralel bildirim gönderimi
        const sendPromises = selectedUsers.map(userId => {
          const payload = {
            title: values.title,
            body: values.desc,
            USERID: userId,
            icerikTuru: "kullanici" 
          };
          return axios.post(NOTIFICATION_POST_URL, payload);
        });

        await Promise.all(sendPromises);
        showToast(true, "Bildirimler başarıyla gönderildi.");
        validation.resetForm();
        setSelectedUsers([]);
      } catch (error) {
        showToast(false, "Gönderim sırasında hata oluştu.");
      }
    },
  });

  // --- YARDIMCI FONKSİYONLAR ---
  const handleSelectChangeUsers = (event) => {
    const selectedOptions = Array.from(event.target.selectedOptions, (option) => option.value);
    setSelectedUsers(selectedOptions);
  };

  const showToast = (success, message) => {
    toastr.options = { positionClass: "toast-top-right", progressBar: true };
    success ? toastr.success(message) : toastr.error(message);
  };

  // Arama Filtrelemesi
  const filteredUsers = users.filter(user => 
    user.Users_Name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Bildirim Gönder" />

          <Row>
            <Col lg="10" className="mx-auto">
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Yeni Bildirim</CardTitle>

                  <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); }}>
                    <Row>
                      <Col md={12}>
                        <div className="mb-3">
                          <Label>Bildirim Başlığı</Label>
                          <Input
                            name="title"
                            type="text"
                            placeholder="Başlık giriniz..."
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.title}
                            invalid={validation.touched.title && !!validation.errors.title}
                          />
                          <FormFeedback>{validation.errors.title}</FormFeedback>
                        </div>

                        <div className="mb-3">
                          <Label>Bildirim İçeriği (Açıklama)</Label>
                          <Input
                            name="desc"
                            type="textarea"
                            rows="3"
                            placeholder="Mesajınızı buraya yazın..."
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.desc}
                            invalid={validation.touched.desc && !!validation.errors.desc}
                          />
                          <FormFeedback>{validation.errors.desc}</FormFeedback>
                        </div>
                      </Col>

                      <hr className="my-4" />

                      <Col md={12}>
                        <Label className="fw-bold">Alıcı Kullanıcılar</Label>
                        <div className="mb-3">
                          <Input
                            type="text"
                            className="mb-2"
                            placeholder="Kullanıcı ismine göre filtrele..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                          />
                          <p className="text-muted small">Birden fazla kullanıcı seçmek için 'Ctrl' (Windows) veya 'Command' (Mac) tuşuna basılı tutun.</p>
                          
                          <Input
                            type="select"
                            multiple
                            className="form-control"
                            style={{ height: "300px" }}
                            value={selectedUsers}
                            onChange={handleSelectChangeUsers}
                          >
                            {filteredUsers.map((user) => (
                              <option key={user.ID} value={user.ID}>
                                {user.Users_Name} (ID: {user.ID})
                              </option>
                            ))}
                          </Input>
                        </div>
                        <div className="text-end">
                           <Badge color="info" className="p-2">{selectedUsers.length} kullanıcı seçildi</Badge>
                        </div>
                      </Col>
                    </Row>

                    <div className="mt-4 text-center">
                      <Button type="submit" color="primary" className="btn-lg w-md">
                        <i className="mdi mdi-send me-1"></i> Bildirimleri Gönder
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EcommerceAddProduct;